import ToastMsg from "@Helper/ToastMsg.js";
import mobile from "@Images/log-in.png";
import "@Styles/mandate.css";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "semantic-ui-react";
import Heading from "../../Common/MainHeading";

import {
  checkForOrderId,
  createOrderCard,
  setNewMpin,
} from "@Redux/Authenticate/action";
import { getUserDetail } from "@Redux/GeneralDetails/action";
import { connect } from "react-redux";
import { withRouter } from "../../../../hooks/withRouter";


const options = {
  position: "top-center",
  autoClose: 2000,
  limit: 1,
  closeButton: false,
};
const optInput = {
  display: "inline",
  float: "left",
  width: "3.3rem",
  padding: "24px 20px",
  margin: "0 5px",
  // marginRight: 10,
  backgroundColor: "#FFFFFF",
  border: "none",
  borderRadius: 15,
  outline: "none",
  fontWeight: 600,
  textAlign: "center",
  redirect_url: "",
  font: "Roboto",
};
class ResetMpin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enterMPIN: "",
      confirmMPIN: "",
      is_enable: true,
      toast_disbled: false,
    };
  }

  handleMpin = (event) => {
    const value = event.replace(/\D/g, "");
    this.setState({ enterMPIN: value });
  };
  handleChange = (event) => {
    const value = event.replace(/\D/g, "");
    this.setState({ confirmMPIN: value });
  };

  notify = () => {
    return toast.error("MPIN Do not match !!", { ...options });
  };

  notifyMpin = (err) => {
    return toast.error(err, { ...options });
  };

  notifySuccess = (success) => {
    return toast.success(success, { ...options });
  };

  createMpin = () => {
    this.setState({ is_enable: true });
    let { enterMPIN, confirmMPIN } = this.state;
    let token = this.props?.user?.User?.token || this.props?.user?.User;

    if (enterMPIN === confirmMPIN) {
      this.props
        .setNewMpin(token, parseInt(enterMPIN))
        .then((res) => {
          if (res.status === 200) {
            nv("event", "MPIN Creation", { "create mpin": true }, "100", 1);
            localStorage.removeItem("isForgot");
            this.notifySuccess(res.data.message);

            this.props
              .getUserDetail(token)
              .then((res) => {
                let nv_data = res?.data?.data?.customusermodel;

                let user_data_nv = {
                  mobile: nv_data?.phone_number,
                  email: res?.data?.data?.email,
                  name: nv_data?.first_name + " " + nv_data?.last_name,
                  "preferred language": "en",
                  registrationStartDate:res.data.data.created_at
                };

                let user_data = {
                  mobile: `91${nv_data.phone_number}`,
                  gender: nv_data?.gender,
                  birth_date: nv_data?.date_of_birth,
                  "preferred language": "en",
                  registrationStartDate:res.data.data.created_at,
                  email: res?.data?.data?.email,
                  name: nv_data?.first_name + " " + nv_data?.last_name,
                };

                let result_nv = nv_data?.gender ? user_data : user_data_nv;

                nv("user", res?.data?.data?.id, result_nv);

                nv(
                  "event",
                  "Email Id Registeration",
                  {
                    mobile: `91${nv_data.phone_number}`,
                    email: res?.data?.data?.email,
                    name: nv_data?.first_name + " " + nv_data?.last_name,
                    "preferred language": "en",
                  },
                  "100",
                  1
                );
              })
              .catch((err) => {
                if (err.response?.status === 401) {
                  window.location.href = "/";
                  localStorage.removeItem("gpay_token");
                }
                let error = err?.response?.data?.error;

                ToastMsg(error, "error");
                // console.log(err);
              });

            if (localStorage.getItem("in_new_user")) {
              // this.props.history.push("/referralCode");
              return;
            } else {
              this.props.history.push("/dashboard_s");
            }

          } else {
            let error = res.data.error;
            if (!this.state.toast_disbled) {
              this.setState({ toast_disbled: true });
              this.notifyMpin(error);
              setTimeout(() => {
                this.setState({ toast_disbled: false });
              }, 4000);
            }
          }
        })
        .catch((err) => {
          this.setState({ loader: false });
          if (err.response?.status === 401) {
            window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    } else {
      if (!this.state.toast_disbled) {
        this.setState({ toast_disbled: true });
        this.notify();
        setTimeout(() => {
          this.setState({ toast_disbled: false });
        }, 4000);
      }
    }
  };

  render() {
    let is_user_new = localStorage.getItem("in_new_user");

    return (
      <div className="main_div">
        <div className="container">
          <div className="pb-4">
            {/* <div style={{ display:"inline"}}>
            <img src={arrowleft} className ="arrowleft" onClick={() => this.props.history.goBack("/")}/>
            <h3 className="page-title font-weight-bold mb-3">
            Reset MPIN
              </h3>
          </div> */}
            <Heading
              headingText={
                is_user_new === "true" ? "Create MPIN" : "Reset MPIN"
              }
              onClick={() => this.props.history.goBack("/")}
              history={this.props.history}
            />
            <div className="wrapper-content">
              <div className="card-height px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg">
                <div className="h-100 d-flex flex-column justify-content-between">
                  <div>
                    <img
                      src={mobile}
                      style={{ width: 115, height: 106 }}
                      className="mobile_img_c"
                      alt="PaymeIndia"
                    />
                  </div>
                  <Form className="reset_mpin">
                    <Form.Field className="pt-5 mb-3">
                      <label className="main__page font-size-18" name="otp">
                        MPIN
                      </label>
                      <div>
                        <OtpInput
                          containerStyle="otpCover"
                          value={this.state.enterMPIN}
                          onChange={this.handleMpin}
                          numInputs={6}
                          inputType="number"
                          renderSeparator={<span></span>}
                          renderInput={(props) => <input {...props} style={optInput} />}
                        />
                      </div>
                    </Form.Field>
                    <Form.Field className="pt-5 mb-3">
                      <label className="main__page font-size-18" name="otp">
                        Confirm MPIN
                      </label>
                      <div>
                        <OtpInput
                          containerStyle="otpCover"
                          value={this.state.confirmMPIN}
                          onChange={this.handleChange}
                          numInputs={6}
                          inputType="number"
                          renderSeparator={<span></span>}
                          renderInput={(props) => <input {...props} style={optInput} />}
                        />
                      </div>
                    </Form.Field>
                  </Form>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center pt-4">
            {!this.state.enterMPIN && !this.state.confirmMPIN ? (
              <button className="btn bg-orange text-white rounded-pill px-5 py-3 mb-3 opacity-50">
                Continue
              </button>
            ) : (
              <button
                onClick={this.createMpin}
                className="btn bg-orange text-white rounded-pill px-5 py-3 mb-3"
              >
                Continue
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps, {
  setNewMpin,
  createOrderCard,
  checkForOrderId,
  getUserDetail,
})(ResetMpin));
